import { render, staticRenderFns } from "./CompensationBanner.vue?vue&type=template&id=abf0c618&"
import script from "./CompensationBanner.vue?vue&type=script&lang=js&"
export * from "./CompensationBanner.vue?vue&type=script&lang=js&"
import style0 from "./CompensationBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports